import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=4fef132c&"
import script from "./Invoices.vue?vue&type=script&lang=ts&"
export * from "./Invoices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports